// This is duplicated in da-aloha please sync with that as we can't include
// aloha on frontend code.
export var PapiVersions = /*#__PURE__*/ function(PapiVersions) {
    PapiVersions[PapiVersions["v20181102"] = 20181102] = "v20181102";
    PapiVersions[PapiVersions["v20190117"] = 20190117] = "v20190117";
    PapiVersions[PapiVersions["v20190423"] = 20190423] = "v20190423";
    PapiVersions[PapiVersions["v20191101"] = 20191101] = "v20191101";
    PapiVersions[PapiVersions["v20230710"] = 20230710] = "v20230710";
    return PapiVersions;
}({});
export const LATEST_VERSION = 20230710;
export const CANONICAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
export const LOCAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
export const CANONICAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.com/_puppy/';
export const LOCAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.lan/_puppy/';

//# sourceMappingURL=constants.js.map